<div ridangoAriaList>
    <div
        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
        *ngIf="helperService.isAllowedPath('/account') && ridangoAuth.getLoginStatus()"></div>

    <li class="flex h-14 items-center pl-6 text-base" *ngIf="helperService.isAllowedPath('/account/messages')">
        <div class="mr-4 flex h-8 w-8 items-center">
            <ion-icon
                class="absolute text-[1.5rem] text-white dark:text-contrast-yellow"
                [src]="(assetsPath$ | async) + '/img/menu/mail.svg'"
                aria-hidden="true"></ion-icon>
            <ng-container *ngIf="receivedMessagesCount$ | async as receivedCount">
                <div
                    class="vl-app-light:bg-[#d04d43] received-count relative text-white dark:border dark:border-solid dark:border-black dark:bg-contrast-yellow dark:text-contrast-black"
                    *ngIf="env.HEADER?.SHOW_MESSAGES && receivedCount?.unread > 0"
                    aria-hidden="true">
                    {{ receivedCount?.unread }}
                </div>
            </ng-container>
        </div>
        <button
            class="h-14 text-base text-white dark:text-contrast-yellow"
            #messages="routerLinkActive"
            [class.font-bold]="messages.isActive"
            [attr.aria-current]="messages.isActive ? 'page' : null"
            [routerLink]="'/account/messages' | localize"
            [attr.aria-label]="
                ('HEADER_MESSAGES' | translate) +
                ', ' +
                ((receivedMessagesCount$ | async)?.unread > 0
                    ? ('X_UNREAD_MESSAGES' | translate: { count: (receivedMessagesCount$ | async)?.unread })
                    : ('NO_NEW_MESSAGES' | translate))
            "
            (click)="closeMobileMenu()"
            routerLinkActive>
            <span> {{ 'HEADER_MESSAGES' | translate }}</span>
        </button>
    </li>

    <div
        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
        *ngIf="helperService.isAllowedPath('/account/messages')"></div>

    <li class="flex h-14 items-center pl-6 text-base" *ngIf="helperService.isAllowedPath('/disruption-messages')">
        <div class="mr-4 flex h-8 w-8 items-center">
            <ion-icon
                class="text-[1.5rem] text-white dark:text-contrast-yellow"
                aria-hidden="true"
                name="warning"></ion-icon>
        </div>
        <button
            class="h-14 text-base text-white dark:text-contrast-yellow"
            #disruptionMessageLink="routerLinkActive"
            [class.font-bold]="disruptionMessageLink.isActive"
            [attr.aria-current]="disruptionMessageLink.isActive ? 'page' : null"
            [routerLink]="'/disruption-messages' | localize"
            [queryParams]="{ backButton: env.DISRUPTION_MESSAGES?.HIDE_BACK_BUTTON ? true : null }"
            (click)="closeMobileMenu()"
            routerLinkActive>
            <span> {{ 'HEADER_DISRUPTION_MESSAGES' | translate }}</span>
        </button>
    </li>
    <div
        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
        *ngIf="helperService.isAllowedPath('/disruption-messages')"></div>

    <li class="flex h-14 items-center pl-6 text-base">
        <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
            <ion-icon
                class="text-[1.5rem] text-white dark:text-contrast-yellow"
                [src]="isVastmanlandApp && (assetsPath$ | async) + '/img/menu/timetables.svg'"
                [name]="!isVastmanlandApp && 'link'"
                aria-hidden="true"></ion-icon>
        </div>
        <a
            class="flex h-14 w-full items-center justify-between break-all text-base text-white dark:text-contrast-yellow"
            [attr.aria-label]="'MAIN_MENU_ITEM_DESCRIPTION' | translate: { item: 'MAIN_MENU_TIMETABLES' | translate }"
            (click)="closeMobileMenu(true, { title: 'MAIN_MENU_TIMETABLES' })"
            href="https://www.vl.se/tidtabeller/ladda-ner-tidtabell/"
            target="_blank">
            {{ 'MAIN_MENU_TIMETABLES' | translate }}
            <ion-icon
                class="mr-6 text-[1.5rem] text-white dark:text-contrast-yellow"
                name="open-outline"
                aria-hidden="true"></ion-icon>
        </a>
    </li>
    <div
        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"></div>

    <li class="flex h-14 items-center pl-6 text-base">
        <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
            <ion-icon
                class="text-[1.5rem] text-white dark:text-contrast-yellow"
                [src]="isVastmanlandApp && (assetsPath$ | async) + '/img/menu/comment-lines.svg'"
                [name]="!isVastmanlandApp && 'link'"
                aria-hidden="true"></ion-icon>
        </div>
        <a
            class="flex h-14 w-full items-center justify-between break-all text-base text-white dark:text-contrast-yellow"
            [attr.aria-label]="'MAIN_MENU_ITEM_DESCRIPTION' | translate: { item: 'FEEDBACK_FORM' | translate }"
            (click)="closeMobileMenu(true, { title: 'MAIN_MENU_LEAVE_FEEDBACK' })"
            href="https://www.vl.se/innehall/fraga-berom-onskemal-eller-synpunkt/"
            target="_blank">
            {{ 'MAIN_MENU_LEAVE_FEEDBACK' | translate }}
            <ion-icon
                class="mr-6 text-[1.5rem] text-white dark:text-contrast-yellow"
                name="open-outline"
                aria-hidden="true"></ion-icon>
        </a>
    </li>
    <ng-container *ngIf="env.MOBILE_MENU_CUSTOMIZATION?.SHOW_ACCESSIBILITY_ITEM">
        <div class="menu-divider border-primary-lighter ml-16 mr-8 border-solid dark:border-grey-white_smoke"></div>
        <li class="flex h-14 items-center pl-6 text-base">
            <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
                <div
                    class="vl-app-light:bg-grey-white_smoke flex h-6 w-6 min-w-[1.5rem] items-center justify-center rounded-full bg-primary-text text-white dark:bg-contrast-yellow">
                    <ion-icon
                        class="text-[1rem] text-primary dark:text-contrast-black"
                        aria-hidden="true"
                        name="accessibility"></ion-icon>
                </div>
            </div>
            <a
                class="flex h-14 w-full items-center justify-between break-all text-base text-white dark:text-contrast-yellow"
                [href]="'MAIN_MENU_ACCESSIBILITY_LINK' | translate"
                [attr.aria-label]="
                    'MAIN_MENU_ITEM_DESCRIPTION' | translate: { item: 'MAIN_MENU_ACCESSIBILITY_STATEMENT' | translate }
                "
                (click)="closeMobileMenu(true, { title: 'MAIN_MENU_ACCESSIBILITY_STATEMENT' })"
                target="_blank">
                {{ 'MAIN_MENU_ACCESSIBILITY_STATEMENT' | translate }}
                <ion-icon
                    class="mr-6 text-[1.5rem] text-white dark:text-contrast-yellow"
                    name="open-outline"
                    aria-hidden="true"></ion-icon>
            </a>
        </li>
    </ng-container>

    <div
        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
        *ngIf="ridangoAuth.getLoginStatus() && !env.HEADER.HIDE_FEEDBACK"></div>

    <li class="flex h-14 items-center pl-6 text-base" *ngIf="ridangoAuth.getLoginStatus() && !env.HEADER.HIDE_FEEDBACK">
        <div class="mr-6 h-6 w-6">
            <mat-icon
                class="text-[1.5rem] text-white dark:text-contrast-yellow"
                icon
                aria-hidden="true"
                svgIcon="feedback"
                alt="feedback"></mat-icon>
        </div>

        <button
            class="flex h-14 w-full items-center justify-between break-all text-base text-white dark:text-contrast-yellow"
            #feedbackLink="routerLinkActive"
            [class.font-bold]="feedbackLink.isActive"
            [attr.aria-current]="feedbackLink.isActive ? 'page' : null"
            [routerLink]="'/feedback' | localize"
            (click)="closeMobileMenu()"
            routerLinkActive>
            {{ 'MORE_MENU_FEEDBACK' | translate }}
        </button>
    </li>
</div>
<ion-accordion-group [multiple]="true" [value]="['paymentsTickets', 'contact-us', 'info', 'terms', 'settings']">
    <ion-accordion
        class="vl-app-light vl-app-light:bg-[#085667] dark:dark-accordion bg-primary-lighter VL-custom-chevron mb-2 dark:bg-contrast-grey dark:text-contrast-yellow"
        toggleIcon="caret-forward"
        toggleIconSlot="start"
        value="paymentsTickets">
        <ion-item class="vl-app-light:text-white" slot="header" color="primary-lighter">
            <ion-label class="text-base font-bold dark:text-contrast-yellow">
                {{ 'MAIN_MENU_PAYMENTS_TICKETS' | translate }}
            </ion-label>
        </ion-item>
        <div class="ion-padding bg-[var(--color-primary)] dark:bg-contrast-black" slot="content">
            <div ridangoAriaList>
                <li class="flex h-14 items-center pl-6 text-base">
                    <div class="mr-4 flex h-8 w-8 items-center">
                        <ion-icon
                            class="text-[2rem] text-white dark:text-contrast-yellow"
                            [src]="isVastmanlandApp && (assetsPath$ | async) + '/img/menu/your-tickets.svg'"
                            [name]="!isVastmanlandApp && 'ticket-outline'"
                            aria-hidden="true"></ion-icon>
                    </div>
                    <button
                        class="flex h-14 w-full items-center justify-between break-all text-base text-white dark:text-contrast-yellow"
                        #ticketsButtonButton="routerLinkActive"
                        [class.font-bold]="ticketsButtonButton.isActive"
                        [attr.aria-current]="ticketsButtonButton.isActive ? 'page' : null"
                        [routerLink]="'/account/tickets' | localize"
                        (click)="closeMobileMenu()"
                        routerLinkActive="font-bold">
                        {{ 'TICKET_TEXT_TICKETS' | translate }}
                    </button>
                </li>

                <div
                    class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"></div>

                <ng-container *ngFor="let link of paymentsTicketsSection; let last = last">
                    <li class="flex h-14 items-center pl-6 text-base">
                        <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
                            <ion-icon
                                class="text-[1.5rem] text-white dark:text-contrast-yellow"
                                [src]="isVastmanlandApp && (assetsPath$ | async) + '/img/menu/' + link.srcIcon"
                                [name]="!isVastmanlandApp && 'link'"
                                aria-hidden="true"></ion-icon>
                        </div>
                        <a
                            class="flex h-14 w-full items-center justify-between break-all text-base text-white dark:text-contrast-yellow"
                            [href]="link.link"
                            [attr.aria-label]="
                                'MAIN_MENU_ITEM_ABOUT_DESCRIPTION' | translate: { item: link.title | translate }
                            "
                            (click)="closeMobileMenu(true, link)"
                            target="_blank">
                            {{ link.title | translate }}
                            <ion-icon
                                class="mr-6 text-[1.5rem] text-white dark:text-contrast-yellow"
                                name="open-outline"
                                aria-hidden="true"></ion-icon>
                        </a>
                    </li>
                    <div
                        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
                        *ngIf="!last"></div>
                </ng-container>
            </div>
        </div>
    </ion-accordion>

    <ion-accordion
        class="vl-app-light:bg-[#085667] dark:dark-accordion bg-primary-lighter VL-custom-chevron mb-2 dark:bg-contrast-grey dark:text-contrast-yellow"
        toggleIcon="caret-forward"
        toggleIconSlot="start"
        value="contact-us">
        <ion-item class="vl-app-light:text-white" slot="header" color="primary-lighter">
            <ion-label class="text-base font-bold dark:text-contrast-yellow">
                {{ 'MORE_MENU_CONTACT_US' | translate }}
            </ion-label>
        </ion-item>
        <div class="ion-padding bg-[var(--color-primary)] dark:bg-contrast-black" slot="content">
            <div ridangoAriaList>
                <li class="flex h-14 items-center pl-6 text-base">
                    <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
                        <ion-icon
                            class="vl-app-light:block hidden text-[1.5rem] text-white dark:text-contrast-yellow"
                            [src]="isVastmanlandApp && (assetsPath$ | async) + '/img/menu/at-solid.svg'"
                            [name]="!isVastmanlandApp && 'ticket-outline'"
                            aria-hidden="true"></ion-icon>
                        <mat-icon
                            class="vl-app-light:!hidden text-[1.5rem] text-white dark:text-contrast-yellow"
                            aria-hidden="true">
                            mail
                        </mat-icon>
                    </div>
                    <a
                        class="flex h-14 w-full items-center break-all text-base text-white dark:text-contrast-yellow"
                        [attr.aria-label]="'HEADER_MAIL_US' | translate"
                        (click)="closeMobileMenu(true, { title: 'HEADER_MAIL_US' })"
                        href="mailto:{{ 'MAIL_AT_LINK' | translate }}"
                        target="_blank">
                        {{ 'HEADER_MAIL_US' | translate }}
                    </a>
                </li>

                <div
                    class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"></div>

                <li class="flex h-14 items-center pl-6 text-base">
                    <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
                        <mat-icon class="text-[1.5rem] text-white dark:text-contrast-yellow" aria-hidden="true"
                            >call
                        </mat-icon>
                    </div>
                    <a
                        class="text-base text-white dark:text-contrast-yellow"
                        [attr.aria-label]="('PHONE_NUMBER' | translate) + ', ' + ('FOOTER_PHONE_TEXT' | translate)"
                        [href]="'tel:' + ('FOOTER_PHONE_TEXT' | translate)"
                        (click)="onPhoneNrClick()">
                        {{ 'FOOTER_PHONE_TEXT' | translate }}
                    </a>
                </li>
            </div>
        </div>
    </ion-accordion>

    <ion-accordion
        class="vl-app-light:bg-[#085667] dark:dark-accordion bg-primary-lighter VL-custom-chevron mb-2 dark:bg-contrast-grey dark:text-contrast-yellow"
        toggleIcon="caret-forward"
        toggleIconSlot="start"
        value="info">
        <ion-item class="vl-app-light:text-white" slot="header" color="primary-lighter">
            <ion-label class="text-base font-bold dark:text-contrast-yellow">
                {{ 'MORE_MENU_INFO' | translate }}
            </ion-label>
        </ion-item>
        <div class="ion-padding bg-[var(--color-primary)] dark:bg-contrast-black" slot="content">
            <div ridangoAriaList>
                <li class="flex h-14 items-center pl-6 text-base" *ngIf="helperService.isAllowedPath('/about')">
                    <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
                        <ion-icon
                            class="text-[1.5rem] text-white dark:text-contrast-yellow"
                            [src]="isVastmanlandApp && (assetsPath$ | async) + '/img/menu/circle-info-solid.svg'"
                            [name]="!isVastmanlandApp && 'information-circle-outline'"
                            aria-hidden="true"></ion-icon>
                    </div>
                    <button
                        class="text-white dark:text-contrast-yellow"
                        #aboutLink="routerLinkActive"
                        [class.font-bold]="aboutLink.isActive"
                        [attr.aria-current]="aboutLink.isActive ? 'page' : null"
                        [routerLink]="'/about' | localize"
                        (click)="closeMobileMenu()"
                        routerLinkActive>
                        {{ 'MORE_MENU_ABOUT_APP' | translate }}
                    </button>
                </li>

                <div
                    class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"></div>

                <li class="flex h-14 items-center pl-6 text-base">
                    <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
                        <ion-icon
                            class="text-[1.5rem] text-white dark:text-contrast-yellow"
                            [src]="isVastmanlandApp && (assetsPath$ | async) + '/img/menu/circle-question-solid.svg'"
                            [name]="!isVastmanlandApp && 'link'"
                            aria-hidden="true"></ion-icon>
                    </div>
                    <a
                        class="flex h-14 w-full items-center justify-between break-all text-base text-white dark:text-contrast-yellow"
                        [attr.aria-label]="'MAIN_MENU_ITEM_DESCRIPTION' | translate: { item: 'FAQ' | translate }"
                        (click)="closeMobileMenu(true, { title: 'FAQ' })"
                        href="https://www.vl.se/fragorochsvar"
                        target="_blank">
                        {{ 'FAQ' | translate }}
                        <ion-icon
                            class="mr-6 text-[1.5rem] text-white dark:text-contrast-yellow"
                            name="open-outline"
                            aria-hidden="true"></ion-icon>
                    </a>
                </li>
            </div>
        </div>
    </ion-accordion>

    <ion-accordion
        class="vl-app-light:bg-[#085667] dark:dark-accordion bg-primary-lighter VL-custom-chevron mb-2 dark:bg-contrast-grey dark:text-contrast-yellow"
        toggleIcon="caret-forward"
        toggleIconSlot="start"
        value="terms">
        <ion-item class="vl-app-light:text-white" slot="header" color="primary-lighter">
            <ion-label class="text-base font-bold dark:text-contrast-yellow">
                {{ 'MENU_TITLE_TERMS' | translate }}
            </ion-label>
        </ion-item>
        <div class="ion-padding bg-[var(--color-primary)] dark:bg-contrast-black" slot="content">
            <div ridangoAriaList>
                <ng-container *ngFor="let link of termsSectionLinks; let last = last">
                    <li class="flex h-14 items-center pl-6 text-base">
                        <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
                            <ion-icon
                                class="text-[1.5rem] text-white dark:text-contrast-yellow"
                                [src]="isVastmanlandApp && (assetsPath$ | async) + '/img/menu/' + link.srcIcon"
                                [name]="!isVastmanlandApp && 'link'"
                                aria-hidden="true"></ion-icon>
                        </div>
                        <a
                            class="flex h-14 w-full items-center justify-between break-all text-base text-white dark:text-contrast-yellow"
                            [href]="link.link | translate"
                            [attr.aria-label]="
                                'MAIN_MENU_ITEM_DESCRIPTION' | translate: { item: link.title | translate }
                            "
                            (click)="closeMobileMenu(true, link)"
                            target="_blank">
                            {{ link.title | translate }}
                            <ion-icon
                                class="mr-6 text-[1.5rem] text-white dark:text-contrast-yellow"
                                name="open-outline"
                                aria-hidden="true"></ion-icon>
                        </a>
                    </li>
                    <div
                        class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
                        *ngIf="!last"></div>
                </ng-container>
            </div>
        </div>
    </ion-accordion>

    <ion-accordion
        class="vl-app-light:bg-[#085667] dark:dark-accordion bg-primary-lighter VL-custom-chevron mb-2 dark:bg-contrast-grey dark:text-contrast-yellow"
        toggleIcon="caret-forward"
        toggleIconSlot="start"
        value="settings">
        <ion-item class="vl-app-light:text-white" slot="header" color="primary-lighter">
            <ion-label class="text-base font-bold dark:text-contrast-yellow">
                {{ 'MORE_MENU_SETTINGS' | translate }}
            </ion-label>
        </ion-item>
        <div class="ion-padding bg-[var(--color-primary)] dark:bg-contrast-black" slot="content">
            <div ridangoAriaList>
                <li
                    class="flex h-14 items-center pl-6 text-base"
                    *ngIf="ridangoAuth.getLoginStatus() && !env.HEADER?.HIDE_PAYMENT_SETTINGS">
                    <div class="mr-6 h-6 w-6">
                        <mat-icon
                            class="text-[1.5rem] text-white dark:text-contrast-yellow"
                            icon
                            aria-hidden="true"
                            svgIcon="coins"
                            alt="coins"></mat-icon>
                    </div>
                    <button
                        class="text-white dark:text-contrast-yellow"
                        #link2="routerLinkActive"
                        [class.font-bold]="link2.isActive"
                        [attr.aria-current]="link2.isActive ? 'page' : null"
                        [routerLink]="'/purchase/wallet' | localize"
                        (click)="closeMobileMenu()"
                        routerLinkActive>
                        {{ 'MORE_MENU_PAYMENT_SETTING' | translate }}
                    </button>
                </li>
                <div
                    class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
                    *ngIf="ridangoAuth.getLoginStatus() && !env.HEADER?.HIDE_PAYMENT_SETTINGS"></div>
                <li class="flex h-14 items-center pl-6 text-base">
                    <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
                        <ion-icon
                            class="text-[1.5rem] text-white dark:text-contrast-yellow"
                            aria-hidden="true"
                            name="notifications"></ion-icon>
                    </div>
                    <button
                        class="flex h-14 w-full items-center break-all text-white dark:text-contrast-yellow"
                        #link7="routerLinkActive"
                        [class.font-bold]="link7.isActive"
                        [attr.aria-current]="link7.isActive ? 'page' : null"
                        [routerLink]="'/account/notification-settings' | localize"
                        (click)="closeMobileMenu()"
                        routerLinkActive="font-bold">
                        {{ 'MY_ACCOUNT_NOTIFICATION_SETTINGS' | translate }}
                    </button>
                </li>
                <div
                    class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"></div>
                <li class="flex h-14 items-center pl-6 text-base">
                    <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
                        <div
                            class="vl-app-light:bg-grey-white_smoke flex h-6 w-6 items-center justify-center rounded-full bg-primary-text text-white dark:bg-contrast-yellow">
                            <ion-icon
                                class="text-[1rem] text-primary dark:text-contrast-black"
                                (click)="toggleContrast()"
                                aria-hidden="true"
                                name="accessibility"></ion-icon>
                        </div>
                    </div>
                    <button
                        class="text-white dark:text-contrast-yellow"
                        [attr.aria-label]="
                            (isContrast$ | async)
                                ? ('TURN_OFF_HIGH_CONTRAST_MODE' | translate)
                                : ('TURN_ON_HIGH_CONTRAST_MODE' | translate)
                        "
                        (click)="toggleContrast()"
                        (keydown.enter)="toggleContrast()"
                        (keydown.space)="toggleContrast()">
                        {{ 'ONBOARDING_ACCESSIBILITY' | translate }}
                    </button>
                </li>
                <div
                    class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"></div>
                <li
                    class="flex h-14 items-center pl-6 text-base"
                    *ngIf="!env.HEADER.HIDE_LANGUAGE_SELECTOR && env.IS_MOBILE_APP">
                    <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
                        <ion-icon
                            class="text-[1.5rem] text-white dark:text-contrast-yellow"
                            [attr.src]="(assetsPath$ | async) + '/img/onboarding/language.svg'"
                            aria-hidden="true"></ion-icon>
                    </div>
                    <button class="text-white dark:text-contrast-yellow" (click)="openSelectLanguageMenu()">
                        {{ 'LANGUAGE' | translate }}
                    </button>
                </li>
                <div
                    class="menu-divider border-primary-lighter ml-16 mr-8 border-solid border-white dark:border-contrast-yellow"
                    *ngIf="helperService.isAllowedPath('/profile') && ridangoAuth.getLoginStatus()"></div>
                <li
                    class="flex h-14 items-center pl-6 text-base"
                    *ngIf="helperService.isAllowedPath('/profile') && ridangoAuth.getLoginStatus()">
                    <div class="mr-4 flex h-8 w-8 shrink-0 items-center">
                        <ion-icon
                            class="text-[1.5rem] text-white dark:text-contrast-yellow"
                            aria-hidden="true"
                            name="person"></ion-icon>
                    </div>
                    <button
                        class="h-14 text-base text-white dark:text-contrast-yellow"
                        #link6="routerLinkActive"
                        [class.font-bold]="link6.isActive"
                        [attr.aria-current]="link6.isActive ? 'page' : null"
                        [routerLink]="'/account/profile' | localize"
                        (click)="closeMobileMenu()"
                        routerLinkActive>
                        {{ 'MORE_MENU_MANAGE_ACCOUNT' | translate }}
                    </button>
                </li>
            </div>
        </div>
    </ion-accordion>
</ion-accordion-group>
